
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pixar-ai-generator",
      function () {
        return require("private-next-pages/pixar-ai-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pixar-ai-generator"])
      });
    }
  